import * as React from "react";
// Shared components
import Modal from "components/Modal";
// UI Frameworks
import { Button } from "antd";

interface IProps {
	shouldVisible: boolean;
	onClose: () => void;
}
const TermsOfService: React.FC<IProps> = props => {
	return (
		<Modal
			title="قوانین و مقررات"
			width="60%"
			visible={props.shouldVisible}
			onCancel={props.onClose}
			footer={[
				<Button key="submit" type="primary" onClick={props.onClose}>
					متوجه شدم
				</Button>,
			]}
		>
			<ol>
				<li>
					<span>
						حجم معاملات در ساعات اداری تا سقف ۱۰۰ گرم قابل انجام است ولی خارج از این زمان، محدودیت معاملاتی
						تا سقف ۱ گرم وجود دارد.
					</span>
				</li>
				<li>
					<span>
						در معاملات اعتباری شما می توانید با پرداخت ۱۰% از کل مبلغ، خرید خود را انجام داده و تا ساعت ۱۶
						همان روز فرصت دارید تا باقیمانده مبلغ خرید خود را واریز نمایید. (این قابلیت در جهت رفع موانع نقل
						و انتقال بانکی در نظر گرفته شده است.) در صورت عدم تمایل برای تکمیل خرید، می توانید طلای خریداری
						شده را فروخته و معامله خود را ببندید. شما این نیابت را به ما می دهید که اگر قبل از تسویه مبلغ
						باقیمانده از خرید اعتباری، میزان کاهش قیمت طلای خریداری شده برابر یا بیشتر از رقم پرداخت شده شما
						در آن معامله شد، سیستم طلای شما را به صورت خودکار فروخته و مبلغ زیان را از محل ۱۰ درصدی که شما
						پرداخت کرده اید، واریز نماید. همچنین اگر شما تا ساعت ۱۶ همان روز اقدام به تسویه یا فروش نکنید،
						سیستم به صورت خودکار به قیمت همان ساعت معامله را بسته و سود و زیان آن را به موجودی ریالی شما
						واریز می کند.
					</span>
				</li>
				<li>
					<span>
						در حوادث غیر مترقبه (قوه قاهره) مانند جنگ، زلزله، سیل و… و نوسانات شدید قیمتی که امکان معامله را
						سلب می کند، خرید و فروش در سامانه به صورت خودکار تا اطلاع ثانوی مسدود می گردد.
					</span>
				</li>
				<li>
					<span>
						در صورت فوت یا مفقودی شخصی که در حساب بازری خود دارای طلا و یا موجودی ریالی باشد، بنا بر قوانین
						و مقررات کشور برای موجودی وی تصمیم گیری می شود.
					</span>
				</li>
				<li>
					<span>
						در صورت افشای رمز عبور کاربری، هیچ مسئولیتی پیرامون معاملات وی متوجه بازر نبوده و مسئولیت آن
						تماما متوجه خود شخص می باشد.
					</span>
				</li>
				<li>
					<span>
						در صورت فراموشی رمز عبور، فرآیند بازیابی رمز از طریق شماره موبایل می باشد اما اگر موجودی ریالی و
						طلایی شخص از عدد ۵۰ گرم بالاتر باشد، برای بازیابی رمز عبور باید شخصا با مدارک هویتی در محل بازر
						حاضر شود.
					</span>
				</li>
				<li>
					<span>
						مسئولیت تمامی تراکنش های درون اپلیکیشن با توجه به تایید ۲ مرحله ای کاربر متوجه خود شخص بوده و
						امکان بازگردانی معاملات و تراکنش ها وجود ندارد.
					</span>
				</li>
				<li>
					<span>
						پلن سرمایه گذاری سالانه: اگر طلای مشتری یکسال شمسی در اپلیکیشن سپرده بماند، در پایان یکسال علاوه
						بر موجودی طلای خود، ۵ درصد از وزن طلای خود را به عنوان سود دریافت می کند.
					</span>
				</li>
				<li>
					<span>
						امکان تحویل فیزیکی طلای آب شده برای اوزان زیر ۳۰ گرم وجود نداشته و در صورتی که مجموع موجودی
						طلایی یک شخص در اپلیکیشن به بالاتر از ۳۰ گرم برسد می تواند طلای خود را در بسته بندی هولوگرام دار
						تحویل بگیرد.
					</span>
				</li>
				<li>
					<span>
						در صورتی که برای ثبتنام در مرکز معاملات بازر، یک شخص از شماره موبایل شخص دیگری استفاده کند
						مسئولیت تمام اتفاقات پیش رو متوجه شخص مالک سیم کارت می باشد.
					</span>
				</li>
				<li>
					<span>
						با توجه به اینکه بازیابی رمز عبور از طریق سیم کارت انجام می شود، در صورت انتقال یا فروش سیمکارت،
						شخص مالک حساب باید پیش از انتقال یا فروش سیم کارت تکلیف حساب بازری خود را مشخص کند.
					</span>
				</li>
				<li>
					<span>
						توجه داشته باشید که کد ملی و تصویر کارت ملی برای احراز هویت شما دریافت می شود و بارگذاری آن در
						اپلیکیشن الزامیست.
					</span>
				</li>
				<li>
					<span>
						افزایش موجودی کیف پول کاربران در اپلیکیشن تنها از طریق کارت های بانکی متعلق به شخص صاحب اکانت
						بازر امکان پذیر است.
					</span>
				</li>
			</ol>
		</Modal>
	);
};

export default TermsOfService;
